import { useContext } from 'react';
import { GiftItemBannerContext } from '../contexts/giftItemBannerContext';
import {
  IPersistedAuth,
  IPrismicGiftItemBannerContent,
} from '@monofront/types';
import { IAuthState } from '../contexts';
import { useUserTags } from './useLocalTags';
import { PrismicService } from '../services';
import { useMediaQuery } from './web/useMediaQuery';

export const createUseGiftItemBanner = (
  useAuthentication: () => IAuthState | IPersistedAuth,
  prismicService: PrismicService,
) => {
  return (): IPrismicGiftItemBannerContent | null => {
    const { contents } = useContext(GiftItemBannerContext);
    const { isAuthenticated, customer, isMember } = useAuthentication();
    const customerTags = useUserTags(useAuthentication);
    const isMobile = useMediaQuery(800);

    return (
      contents.find((content) => {
        return (
          content.tag_context &&
          prismicService.tagContextMatches(content.tag_context, {
            tags: { user: customerTags },
            isAuthenticated,
            isMember,
            isWebMobile: isMobile,
            orders: customer?.totalOrderPaid,
          })
        );
      }) || null
    );
  };
};
